$(function () {
  $('#system_admin_user_menu select').on('change', function () {
    $('#system_admin_user_menu form')[0].submit();
  });
});
